<template>
    <div style="min-height: 400px">
        <section v-if="educationPlanId" class="mb-4" >
            <treeselect
                v-model="value"
                :multiple="true"
                :max-height="400"
                :options="organizationOptions"
                placeholder="Выберите"
                :default-expand-level="1"
                :noResultsText="`Ничего не нашлось...`"
                :noOptionsText="`Нет доступных опций`"
                :noChildrenText="`Нет опций`"
            />
        </section>
        <section class="mb-4" >
            <b-field grouped group-multiline>
                <div class="control" v-for="item in selectedValues">
                    <b-tag type="is-info is-light"
                           attached
                           aria-close-label="Убрать"
                           @close="removeItem(item.id)"
                           closable>
                        {{item.name}}
                    </b-tag>
                </div>
            </b-field>
        </section>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { reduce, get, find, map, uniq, filter, each } from 'lodash'
import { NULL_UID } from '../../../../constants'
import { STATUS_APPROVED, STUDENT } from '../../../../store/models/roles/model'
import HasErrors from '../../../../mixins/HasErrors'
import ApplicationMixin from '../../../../mixins/ApplicationMixin'
import UserRolesMixin from '../../../../mixins/UserRolesMixin'
import { LOAD_CHILDREN_OPTIONS, LOAD_ROOT_OPTIONS, ASYNC_SEARCH } from '@riophae/vue-treeselect'
import { TYPE_ROOT } from '../../../../store/models/organizations/model'
import OrganizationFetchMixin from '../../../../mixins/OrganizationFetchMixin'

export default {
    props: {
        educationPlanId: String,
    },
    mixins: [
        HasErrors,
        OrganizationFetchMixin,
    ],
    mounted () {
        this.fetchOrganizationsIfNeeded().then(()=> {
            this.organizationOptions = this.rebuildItems(this.organizationHierarchy)
        })
    },
    computed: {
        ...mapGetters({
            currentOrganizationId: 'e/users/currentOrganizationId',
            organizationQuery: 'e/organizations/query',
            shareQuery: 'e/share/query',
        }),
        organizationHierarchy() {
            return this.organizationQuery().where('type', TYPE_ROOT).with('children.children.children.children.children.children.children.children.children.children').get()
        },
        selectedValues() {
            return this.value ? this.organizationQuery().whereIdIn(this.value).get() : []
        }
    },
    methods: {
        ...mapActions({
            fetchOrganizations: 'e/organizations/fetchItems',
            saveShare: 'e/share/save',
        }),
        removeItem(id) {
            this.value = filter(this.value, itemId => itemId !== id)
        },
        rebuildItems(items) {
            let result = [];
            for(let i in items) {
                result[i] = {
                    id: items[i].id,
                    label: items[i].name,
                }
                if (items[i].children.length !== 0) {
                    result[i].children = this.rebuildItems(items[i].children)
                }
            }
            return result
        },
        loadOptions({ action, parentNode, searchQuery, callback, instanceId }) {
            if (action === ASYNC_SEARCH) {
                const a = map(this.organizationQuery().where(item => item.name.indexOf(searchQuery) !== -1).with('children').with('parent').get(), item => {
                    let it = {
                        id: item.id,
                        label: item.name
                    }
                    if (item.children.length) {
                        it.children = null
                    }
                    return it
                })
                //parentNode.children = a
                callback(null, a)
            }
            if (action === LOAD_ROOT_OPTIONS) {
                let c = map(this.organizationQuery().whereHasNot('parent').get(), item => {
                        return {
                            id: item.id,
                            label: item.name,
                            children: null,
                        }
                    })
                this.organizationOptions = c

            }
            if (action === LOAD_CHILDREN_OPTIONS) {
                const a = map(this.organizationQuery().where('parentId', parentNode.id).with('children').get(), item => {
                    let it = {
                        id: item.id,
                        label: item.name
                    }
                    if (item.children.length) {
                        it.children = null
                    }
                    return it
                })
                parentNode.children = a
            }
        },
        save() {
            let promises = []
            each(this.selectedValues, item => {
                promises.push(this.saveShare({educationPlanId: this.educationPlanId, organizationId: item.id}))
            })
            return Promise.all(promises)
        },

        reject() {

        }
    },
    data () {
        return {
            value: [],
            organizationOptions: []
        }
    },
    watch: {

    }
}
</script>